<template>
  <div class="runs-box">
    <div class="table-loader" v-if="exclusive.loading && !exclusive.list.length">
      <ellipsis-loader></ellipsis-loader>
      <div class="loader-title">{{ $t('dispatch.rsvpTable.loadingData.title') }}</div>
      <div class="loader-text">{{ $t('dispatch.rsvpTable.loadingData.content') }}</div>
    </div>

    <div class="table-scroll" v-show="exclusive.list.length && !exclusive.loading">
      <table class="runs-table" id="exclusive-table">
        <thead v-if="!isMobile">
          <th class="check"></th>
          <th class="map"></th>
          <th class="ids">RSVP ID</th>
          <th class="date">Pickup Time</th>
          <th class="locs pickup">Pickup</th>
          <th class="locs dropoff">Dropoff</th>
          <th class="driver-payment">Driver Payment</th>
          <th class="flight-info">Flight Info</th>
          <th class="pax">PAX</th>
          <th class="service">Service Type</th>
        </thead>
        <tbody>
          <exclusive-row v-for="(rsvp, i) in exclusive.list" :key="i" :rsvp="rsvp" :isMobile="isMobile"></exclusive-row>
        </tbody>
      </table>
    </div>

    <div class="empty-reservations" v-show="!exclusive.list.length && !exclusive.loading">
      <arrow-up></arrow-up>
      <div class="title">Oops. Looks like we found nothing.</div>
      <div class="content">
        We can't find any reservations for that filter.<br/>
        Please use another one from the form at the top.
      </div>
    </div>

  </div>
</template>

<script>
import ArrowUp from '@/components/Partials/LoadingAnimation/ArrowUp'
import EllipsisLoader from '@/components/Partials/LoadingAnimation/Ellipsis'
import ExclusiveRow from './ExclusiveRow'

export default {
  name: 'exclusive-table',
  components: { ArrowUp, EllipsisLoader, ExclusiveRow },
  data () {
    return {
      isMobile: false
    }
  },
  computed: {
    runs () { return this.$store.state.runs },
    exclusive () { return this.runs.exclusive },
    airports () { return this.$store.state.airports.list },
    selected: {
      get () { return this.runs.selected },
      set (x) { this.$store.commit('runs/setRunsDetails', {selected: x}) }
    },
  },
  methods: {
    getAddress (loc) {
      let index = this.airports.findIndex(x => x.geofenceId === loc.geofenceId)
      if (index > -1) return this.airports[index].title
      return loc.title
    },
    setScreenSize() {
      let self = this
      if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
        self.isMobile = true
      } else {
        self.isMobile = false
      }
    }
  },
  mounted () {
    this.setScreenSize()
  },
  watch: {
    'exclusive.list': function (val) {
      if (val.length) {
        this.$nextTick(() => {
          setTimeout(() => {
            // table width fixer
            let pickup = document.querySelector('#exclusive-table')
            document.querySelector('#exclusive-table thead .pickup')
              .setAttribute('style', `width:${(pickup.offsetWidth - 490) / 2}px`)
            let dropoff = document.querySelector('#exclusive-table')
            document.querySelector('#exclusive-table thead .dropoff')
              .setAttribute('style', `width:${(pickup.offsetWidth - 490) / 2}px`)
          }, 100)
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/_service-types';

.runs-box{
  position: relative;
  height: 100%;
  width: calc(100% - 1px);
}
.table-loader{
  position: relative;
  width: 100%;
  margin: 50px auto;
  text-align: center;

  .loader-title{
    font-weight: 700;
    margin-top: 20px;
    font-size: 20px;
    color: #3F2975;
  }

  .loader-text{
    font-weight: 700;
    margin-top: 10px;
    font-size: 16px;
    color: #777;
  }
}
.table-scroll{
  height: 100%;
  overflow: auto;
  border-top: 1px solid rgba(0, 0, 0, 0.2);
}
.runs-table{
  border-collapse: collapse;
  width: 100%;
  overflow: auto;
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  height: 100%;
  display: table-footer-group;

  thead{
    width: 100%;
    color: #8DA0A9;
    font-size: 12px;
    border-bottom: 1px solid rgba(0,0,0, .3);

    th{
      padding: 5px;
      position: sticky;
      position: -webkit-sticky;
      top: 0;
      z-index: 2;
      background-color: #f5f5f5;
      text-transform: uppercase;

      &.sortable {
        cursor: pointer;
        text-decoration: underline;
        color: #333;
        transition: all 250ms;

        &.disabled {
          pointer-events: none;
          opacity: 0.5;
        }
      }
      input{
        margin-top: 0;
        display: block;
        width: auto;
      }
    }
  }

  tbody{
    width: 100%;

    tr{
      background-color: #fff;
      border-bottom: 1px solid rgba(0, 0, 0, 0.3);
    }
    td{
      padding: 10px 5px;
      text-align: center;
      font-size: 12px;
    }
    input{
      margin-top: 0;
      width: 13px;
    }
    .map-pin{
      color: #fff;
      background-color: #aaa;
      width: 30px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      display: inline-block;
      border-radius: 30px;
      -webkit-transition: all 250ms;
      transition: all 250ms;
    }
    .rsvp-id{
      display: block;
      font-size: 13px;
      outline: none;
      font-weight: 600;
      line-height: 1.45;
    }
    .service-type{
      display: block;
      background: #999;
      margin-bottom: 3px;
    }
  }
  .check { width: 30px; }
  .map{ width: 40px; }
  .ids{ width: 90px; }
  .date{ width: 90px; }
  // .locs{ width: 100%; }
  .driver-payment{ width: 125px; }
  .flight-info{ width: 100px; }
  .service{ width: 130px; }
}

.empty-reservations{
  max-width: 450px;
  margin: 50px auto;
  text-align: center;

  & .title {
    font-weight: 700;
    margin-top: 20px;
    font-size: 20px;
    color: #3F2975;
  }

  & .content{
    font-weight: 700;
    margin-top: 10px;
    font-size: 16px;
    color: #777;
  }
}

@media screen and (max-width: 430px) {
  .empty-reservations, .table-loader {
    margin: 10vh auto;
    width: 90%;
  }

  .runs-table {
    display: table;
    tbody {
      width: 100%;
      padding: 60px 10px;
      display: block;
    }
  } 
}
</style>


// WEBPACK FOOTER //
// src/components/Runs/ExclusiveList.vue